<template>
  <div class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title title="项目信息" />
      </div>
      <div class="section-content">
        <jczh-descriptions
          :info="detailInfo"
          :option="detailConfig"
          :el-attrs="{
            size: 'medium',
            labelStyle: {
              whiteSpace: 'nowrap'
            }
          }"
        >
          <template v-slot:budget="{ value }">
            <span>{{ strToThousands(value || '-') }}</span>
            <span class="m-l-10">万元</span>
            <money-in-cn :money="value * 10000" class="m-l-10" />
          </template>

          <template v-slot:upload="{ value }">
            <upload
              v-if="value"
              :group-id-before="value"
              :props-data="{
                disabled: true
              }"
            />
            <span v-else>-</span>
          </template>
        </jczh-descriptions>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import Upload from '@/components/common/Upload/index'
import MoneyInCn from '@/components/common/MoneyInCn'

// 数据字典
import {
  projectAssetDisposalMethodDict,
  projectTypeDict
} from '@/dictionary/project/common'
import {
  registerInvestTypeDict,
  registerIsFocusPurchaseDict,
  registerStatusDict
} from '@/dictionary/project/register'
import { queryOrganizationDict } from '@/dictionary/query-status'

// 工具
import { strToThousands } from '@/utils/utils'

export default {
  components: {
    BaseSectionTitle,
    Upload,
    MoneyInCn
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      detailConfig: [
        { label: '项目名称', prop: 'projectName' },
        { label: '项目编号', prop: 'projectCode' },
        {
          label: '项目状态',
          prop: 'relatedStatus',
          dictArray: registerStatusDict.array,
          useTag: true
        },
        { label: '创建时间', prop: 'publishTime' },
        { label: '项目概算', prop: 'budget', slotName: 'budget' },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value)?.label || ' - '
        },
        {
          label: '处置方式',
          prop: 'assetDisposalMethod',
          filter: value =>
            projectAssetDisposalMethodDict.translate(value)?.label ||
            projectAssetDisposalMethodDict.EXPENDITURE.label,
          hideFun: () =>
            this.detailInfo.projectType !== projectTypeDict.ASSET_DISPOSAL.value
        },
        {
          label: '组织方式',
          prop: 'projectOrgMethod',
          filter: value =>
            queryOrganizationDict.translate(value)?.label || ' - '
        },
        {
          label: '投资类型',
          prop: 'investmentType',
          filter: value =>
            registerInvestTypeDict.translate(value)?.label || ' - '
        },
        {
          label: '是否集中采购',
          prop: 'centralizedPurchaseType',
          filter: value =>
            registerIsFocusPurchaseDict.translate(value)?.label || ' - '
        },
        {
          label: '项目地点',
          prop: '',
          filter: value =>
            value.country === '中国'
              ? `${value.province + '-' || ''}${value.city + '-' ||
                  ''}${value.area || ''}`
              : value.foreignAddress || ''
        },
        { label: '详细地址', prop: 'address' },
        { label: '上传附件', prop: 'attachmentGroupId', slotName: 'upload' }
      ]
    }
  },

  methods: {
    strToThousands
  }
}
</script>
